import {React} from "react";
import { PortableText } from '@portabletext/react';

const serializers = {
  marks: {
    link: ({children, value}) => {
      const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined
      const target = '_blank'
      const className = 'link'
      return (
        <a href={value.href} rel={rel} target={target} className={className}>
          {children}
        </a>
      )
    },
  },
};
 
// static pages as a component
const ContentSection = ({data})  => {
    return(
        <section >
            <div className="container">
                <div className="row align-items-center text-center-xs">
                    <div className="col-12 col-lg-12">
                        <div className="heading mb-40">
                            <span className="heading-desc"> <PortableText value={data.cc_content} components={serializers} ></PortableText></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>   
    );
}

export default ContentSection;